import {ToastrConfig} from '@kpmg-tax/ui';
import {environment} from '../../../environments/environment';

export const TOASTR_SETTINGS_CONFIG: ToastrConfig = {
  defaultPosition: environment.toastrConfig.defaultPosition,
  successTimeout: environment.toastrConfig.successTimeout,
  warningTimeout: environment.toastrConfig.warningTimeout,
  errorTimeout: environment.toastrConfig.errorTimeout,
  infoTimeout: environment.toastrConfig.infoTimeout,
};
